<script lang="ts" setup>
import { useFetchTransactionDetail } from '~/api/service/transaction/[txnHash]/index.service'
import TransactionsPageDetail from '~/components/@pages/transactions/[txnHash]/TransactionsPageDetail.vue'
import Spinner from '~/components/loading/Spinner.vue'
import NoDataPreview from '~/components/preview/NoDataPreview.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'

const txnHash = useRoute().params.txnHash as string

const ellipsisTxnHash = computed(() => `${txnHash.slice(0, 8)}...${txnHash.slice(-6)}`)
useSeoMeta(getMeta(`Transaction ${ellipsisTxnHash.value}`, `Explore details of Transaction ${ellipsisTxnHash.value}`))

const { data, isLoading } = useFetchTransactionDetail(txnHash)

const isPending = computed(() => data.value?.STATTP === 'PENDING')

useHead(getBreadCrumb())
</script>

<template>
  <Card
    class="mt-4"
    :class="{'!border-explorer-yellow': isPending}"
  >
    <CustomSuspense
      :is-loading="isLoading"
      :is-empty="!data"
    >
      <template #loading>
        <Spinner />
      </template>
      <template #empty>
        <NoDataPreview />
      </template>
      <template #default>
        <TransactionsPageDetail :data="data" />
      </template>
    </CustomSuspense>
  </Card>
</template>

<style scoped>

</style>